/* Component Dependencies */
var eventPlanTemplate = require('templates/eventPlan.hbs');
var AriesComponent = require('libs/aries-component');

AriesComponent.create({
  type: 'eventPlan',
  template: {
    'eventPlan': eventPlanTemplate
  }
});
